import z from 'zod';

export enum TodoStatus {
  ACTIVE = 'active',
  ARCHIVE = 'archive',
}

export const todoStatusSchema = z.enum(TodoStatus);
